import React, { useState } from 'react';

const ExpireReport = () => {
  const productItems = [
    { id: 1, name: 'iphone 15 max ', expiryDate: '2025-12-31', status: 'Active' },
    { id: 2, name: 'Nokia tap4', expiryDate: '2023-10-15', status: 'Expired' },
    { id: 3, name: 'MacBook Air', expiryDate: '2026-01-20', status: 'Active' },
    { id: 4, name: 'Vivo v25 ', expiryDate: '2026-09-01', status: 'Active' },
    { id: 5, name: 'Dell bag ', expiryDate: '2025-01-30', status: 'Expired' },
    { id: 6, name: 'Realme 13 pro', expiryDate: '2025-08-25', status: 'Active' },
    { id: 7, name: 'lenovo thinkpad', expiryDate: '2026-02-15', status: 'Active' },
    { id: 8, name: ' Hp D12', expiryDate: '2024-07-10', status: 'Expired' },
    { id: 9, name: 'Lava 3A', expiryDate: '2026-12-25', status: 'Active' },
   
  ];

  const [filter, setFilter] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const filteredItems = productItems.filter((item) => {
    if (filter === 'active') return item.status === 'Active';
    if (filter === 'expired') return item.status === 'Expired';
    return true;
  });

  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedItems = filteredItems.slice(startIndex, startIndex + itemsPerPage);

  const handlePageChange = (page,filter) => {
    setCurrentPage(page,filter);
  };

  return (
    <div className="p-3">
      <h1 className="text-2xl font-bold mb-4">Expired items report</h1>
      <hr className="mb-4" />

      {/* Filter Section */}
      <div className='float-end'>
      <div className="mb-2 d-flex align-items-center">
        <label htmlFor="filter" className="me-2 fw-semibold">
            Filter by Status:
        </label>
        <select
            id="filter"
            className="form-select w-auto"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
         >
            <option value="all">All</option>
            <option value="active">Active</option>
            <option value="expired">Expired</option>
        </select>
     </div>
        </div>


      {/* Table */}
      <div className="table-responsive text-center my-1 w-100 position-relative">
        <table className="table table-striped table-sm table-bordered">
          <thead>
            <tr className="bg-gray-200">
              <th className="py-2 px-4 border-b">S.No</th>
              <th className="py-2 px-4 border-b">Product Name</th>
              <th className="py-2 px-4 border-b">Expiry Date</th>
              <th className="py-2 px-4 border-b">Status</th>
            </tr>
          </thead>
          <tbody>
            {paginatedItems.map((item, index) => (
              <tr key={item.id} className="hover:bg-gray-100 transition-colors duration-200">
                <td className="py-2 px-4 border-b text-center">{startIndex + index + 1}</td>
                <td className="py-2 px-4 border-b">{item.name}</td>
                <td className="py-2 px-4 border-b text-center">{item.expiryDate}</td>
                <td className="py-2 px-4 border-bottom text-center">
                <span
                    className={`badge px-3 py-1 ${
                    item.status === "Expired" ? "bg-danger text-white" : "bg-success text-white"
                    }`}
                >
                    {item.status}
                </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="mt-4 d-flex justify-content-center align-items-center">
  <button
    className={`btn mx-1 ${
      currentPage === 1 ? "btn-secondary disabled" : "btn-primary"
    }`}
    onClick={() => handlePageChange(currentPage - 1)}
    disabled={currentPage === 1}
  >
    Previous
  </button>

  <span className="mx-3">
    Page {currentPage} of {totalPages}
  </span>

  <button
    className={`btn mx-1 ${
      currentPage === totalPages ? "btn-secondary disabled" : "btn-primary"
    }`}
    onClick={() => handlePageChange(currentPage + 1)}
    disabled={currentPage === totalPages}
  >
    Next
  </button>
</div>

    </div>
  );
};

export default ExpireReport;